import React, { useEffect,useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ProtectedLayout from "../admin/component/ProtectedLayout";
import { NavTransitionLoader } from "../admin/component/MilliyoLoader";
import Sidebar from "../admin/Sidebar";
import TopHeader from "../admin/TopHeader";
import Dashboard from "../admin/Dashboard";
import Categories from "../admin/Category/Categories";
import SubCategories from "../admin/subcategory/SubCategories";
import ListProducts from "../admin/products/ListProduct";
import AddProducts from "../admin/products/AddProduct";
import EditProduct from "../admin/products/EditProduct";
import ViewProduct from "../admin/products/ViewProduct";
import OrderRecevied from "../admin/order/OrderRecevied";
import Users from "../admin/user/Users";
import OrderDetails from "../admin/order/OrderDetails";
import Permission from "../admin/user/Permission";
import BillDesigner from "../admin/print/BillDesigner";
import Keys from "../admin/setting/Keys";
import TaxRates from "../admin/taxmaster/TaxRates";
import StockEntry from "../admin/products/StockEntry";
import Offers from "../admin/offer/Offers";
import Banners from "../admin/banner/Banners";
import Branding from "../admin/branding/List";
import GstReport from "../admin/reports/GstReport";
import Customers from "../admin/customer/Customers";
import ContentBlocks from "./content/ContentBlocks";
import EmailSettings from "./email/EmailSettings";
import Notifications from "../admin/notification/Notifications";
import CustomerOrders from "../admin/customer/CustomerOrders";
import CustomerOrderDetails from "../admin/customer/CustomerOrderDetails";
import Gallery from "../admin/products/Gallery";
import MillingSlots from "../admin/Milling/Slots";
import StoreSettings from "../admin/Store/Settings";
import Stores from "../admin/Store/Stores";
import LiveView from "../admin/Store/LiveView";
import Staff from "../admin/staff/Staff";
import SupportList from "../admin/support/SupportList";
import SupportDetail from "../admin/support/SupportDetail";
import ReeloConsole from "../admin/loyalty/ReeloConsole";
import AuditLog from "../admin/audit/AuditLog";
import BulkAllocate from "../admin/bulk/BulkAllocate";
import BulkStock from "../admin/bulk/BulkStock";
import BulkPrice from "../admin/bulk/BulkPrice";
import Pos from "./pos/Pos";
const AdminApp = () => {
  const dispatch = useDispatch();
  const [deliveryMode, setDeliveryMode] = useState("delivery"); 

  return (
    <ProtectedLayout>
      <div className="tap-top">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.2 5.2a1.1 1.1 0 0 1 1.6 0l5 5a1.1 1.1 0 0 1-1.6 1.6L12 7.6l-4.2 4.2a1.1 1.1 0 0 1-1.6-1.6Zm0 7a1.1 1.1 0 0 1 1.6 0l5 5a1.1 1.1 0 0 1-1.6 1.6L12 14.6l-4.2 4.2a1.1 1.1 0 1 1-1.6-1.6Z" /></svg>
      </div>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-header">
          <TopHeader 
          deliveryMode={deliveryMode} 
          onModeChange={setDeliveryMode} 
        />
        </div>
        <div className="page-body-wrapper mt-4">
          <Sidebar />
          <div className="page-body">
            <NavTransitionLoader />
            <Routes>
              <Route path="/" element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pos" element={<Pos />} />
              <Route path="category" element={<Categories />} />
              <Route path="subcategory" element={<SubCategories />} />
              <Route path="products" element={<ListProducts />} />
              <Route path="order/recevied" element={ <OrderRecevied 
      deliveryMode={deliveryMode} 
      onModeChange={setDeliveryMode} 
    />} />
              <Route path="banner" element={<Banners />} />
              <Route path="branding" element={<Branding />} />
              <Route path="gst-report" element={<GstReport />} />
              <Route path="settings/Users" element={<Users />} />
              <Route path="orders/details/:id" element={<OrderDetails/>} />
              <Route path="taxmaster/list" element={<TaxRates />} />
              <Route path="settings/Permission" element={<Permission />} />
              <Route path="bill-design" element={<BillDesigner />} />
              <Route path="settings/keys" element={<Keys />} />
              <Route path="products/add" element={<AddProducts />} />
              <Route path="products/edit/:id" element={<EditProduct />} />
              <Route path="products/view/:id" element={<ViewProduct />} />
              <Route path="products/stockentry" element={<StockEntry />} />
              <Route path="offer/list" element={<Offers />} />
              {/* /location retired — delivery areas live on /admin/stores */}
              <Route path="/location" element={<Navigate to="/admin/stores" replace />} />
              <Route path="/customer" element={<Customers />} />
              <Route path="/customers/:id/orders" element={<CustomerOrders />} />
              <Route path="/customer/details/:id" element={<CustomerOrderDetails />} />
              <Route path="/notification" element={<Notifications />} />
              <Route path="settings/email" element={<EmailSettings />} />
              <Route path="content" element={<ContentBlocks />} />
              <Route path="products/imageUpload" element={<Gallery />} />
              <Route path="bulk-allocate" element={<BulkAllocate />} />
              <Route path="bulk-stock" element={<BulkStock />} />
              <Route path="bulk-price" element={<BulkPrice />} />
              <Route path="milling/slots" element={<MillingSlots />} />
              <Route path="store/settings" element={<StoreSettings />} />
              <Route path="stores" element={<Stores />} />
              <Route path="staff" element={<Staff />} />
              <Route path="support" element={<SupportList />} />
              <Route path="support/:id" element={<SupportDetail />} />
              <Route path="live-view" element={<LiveView />} />
              <Route path="loyalty" element={<ReeloConsole />} />
              <Route path="audit" element={<AuditLog />} />
            </Routes>
          </div>
          <footer className="footer">
            <div className="container-fluid" style={{ marginBottom: "0px" }}>
              <div className="row">
                <div className="col-md-12 footer-copyright text-center">
                  {/* derived, so it never goes stale again */}
                  <p className="mb-0">© {new Date().getFullYear()} MilliyO · Into Today&#39;s Kitchen, For Tomorrow&#39;s Generation</p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </ProtectedLayout>
  );
};

export default AdminApp;